export default __webpack_public_path__ + "static/media/img-0138-germany-half-face.819d6f03.png";